// Components
import { Table } from '../../components';

// Actions
import {
    fetchBulkRefundDataRequest,
    downloadBulkRefundFileByIdRequest,
} from './redux/bulkRefund.actions';

// Libraries
import React, { useMemo, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

const TableHead = props => {
    return (
        <div className="mail-head clearfix">
            <div className="headTitle">
                <p>Recent Uploaded</p>
            </div>
        </div>
    );
};

const ManageBulkRefundActions = ({ data, downloadRequest }) => {
    const history = useHistory();

    const handleDownload = () => {
        downloadRequest(data.original.requestId);
    };

    const handleViewClick = () => {
        const {
            requestId,
            fileName,
            totalRecordCount,
            totTxnAmt,
        } = data.original;

        if (data.original) {
            history.push(`/bulk-refund/${requestId}`, {
                requestId,
                fileName,
                totalRecordCount,
                totTxnAmt,
            });
        }
    };

    return (
        <div className="userAction  multiItem">
            <button className="view" onClick={handleViewClick} />
            <button className="download" onClick={handleDownload} />
        </div>
    );
};

const BulkRefundTable = ({ actions, bulkRefundData }) => {
    const { tableData, isLoading } = bulkRefundData;

    const fetchData = useCallback(() => {
        // This will get called when the table needs new data
        // You could fetch your data from literally anywhere,
        actions.fetchBulkRefundDataRequest();
    }, [actions]);

    const columnsRecent = useMemo(
        () => [
            { header: 'Request ID', accessor: 'requestId' },
            { header: 'Request status', accessor: 'requestStatus' },
            { header: 'File Name', accessor: 'fileName' },
            { header: 'Created Date', accessor: 'createdDate' },
            { header: 'Total Record Count', accessor: 'totalRecordCount' },
            { header: 'Success Record Count', accessor: 'successRecordCount' },
            { header: 'Pending Record Count', accessor: 'pendingRecordCount' },
            { header: 'Fail Record Count', accessor: 'failRecordCount' },
            { header: 'Amount', accessor: 'totTxnAmt' },
            { header: 'Action', accessor: 'action' },
        ],
        []
    );

    return (
        <>
            <Table
                columns={columnsRecent}
                data={tableData}
                tableHead={<TableHead />}
                error={null}
                fetchData={fetchData}
                tableFilters={null}
                loading={isLoading}
                userActions={data => (
                    <ManageBulkRefundActions
                        data={data}
                        downloadRequest={requestId =>
                            actions.downloadBulkRefundFileByIdRequest({
                                requestId,
                                fileTypeEnum: 'UPLOADED',
                            })
                        }
                    />
                )}
            />
        </>
    );
};

ManageBulkRefundActions.propTypes = {
    data: PropTypes.object,
    downloadRequest: PropTypes.func,
};

BulkRefundTable.propTypes = {
    actions: PropTypes.object,
    auth: PropTypes.object,
    data: PropTypes.object,
    manageBin: PropTypes.object,
    loader: PropTypes.object,
    bulkRefundData: PropTypes.object,
};

const mapStateToProps = ({ auth, loader, actions, bulkRefundData }) => ({
    auth,
    loader,
    actions,
    bulkRefundData,
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        {
            fetchBulkRefundDataRequest,
            downloadBulkRefundFileByIdRequest,
        },
        dispatch
    ),
});
export default connect(mapStateToProps, mapDispatchToProps)(BulkRefundTable);
